import React, { Component } from 'react';
import { authHeaderJson } from '../auth-header';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { List, ListItem, ListItemText, ListItemIcon } from '@material-ui/core';

import EditIcon from '@material-ui/icons/Subject';
import CancelIcon from '@material-ui/icons/CancelOutlined';
import IconRefresh from '@material-ui/icons/Refresh';
import IconFirstPage from '@material-ui/icons/FirstPage';
import IconPrev from '@material-ui/icons/NavigateBefore';
import IconNext from '@material-ui/icons/NavigateNext';
import IconLastPage from '@material-ui/icons/LastPage';
import IconMail from '@material-ui/icons/Mail';


import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { IconButton, Dialog, Button, CircularProgress, AppBar, Typography, Toolbar } from '@material-ui/core'

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit,
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200,
    },
    numberField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 100,
    },
    radio: {
        height: 30,
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
    },
    group: {
        margin: `${theme.spacing.unit}px 0`,
        marginRight: 5,
    },
    editor: {
        height: 320,
    },
    editor2: {
        height: 300
    },
    fab: {
        marginTop: theme.spacing.unit * 2,
        position: 'absolute',
        right: theme.spacing.unit * 2,
    },
    grow: {
        flexGrow: 1,
    },
});


class NotificationsHist extends Component {
    static displayName = NotificationsHist.name;

    constructor(props) {
        super(props);
        this.state = {
            listData: [],
            loading: true,
            dialogOpen: false,
            notDataId: 0,
            datRes: null,
            mailCount: 0,
            textRes: "",
            search: '',
            currentPage: 1,
            pageCount: 0,
        };
        this.handleClose = this.handleClose.bind(this);
    };


    componentDidMount() {
        this.loadNots();
    }

    getDateTime(datstr) {
        if (datstr === null) return '';
        var dat = new Date(datstr);
        var yyyy = dat.getFullYear();
        var mm = dat.getMonth() < 9 ? "0" + (dat.getMonth() + 1) : (dat.getMonth() + 1); // getMonth() is zero-based
        var dd = dat.getDate() < 10 ? "0" + dat.getDate() : dat.getDate();
        var hh = dat.getHours() < 10 ? "0" + dat.getHours() : dat.getHours();
        var min = dat.getMinutes() < 10 ? "0" + dat.getMinutes() : dat.getMinutes();
        var ss = dat.getSeconds() < 10 ? "0" + dat.getSeconds() : dat.getSeconds();
        return "" + dd + "." + mm + "." + yyyy + " " + hh + ":" + min + ":" + ss;
    };

    loadNots() {
        this.setState({ loading: true });

        fetch('api/NotificationResults', { headers: authHeaderJson(), body: JSON.stringify({ page: this.state.currentPage, search: this.state.search, rows: 30 }), method: 'post' })
            .then(response => response.json())
            .then(data => {
                //                console.log(data);
                this.setState({
                    listData: data.results,
                    pageCount: data.pageCount,
                    loading: false
                });
            })
            .catch(err => {
                this.setState({ loading: false });
            });
    }
    firstPage() {
        if (this.state.currentPage > 1) {
            this.setState({ currentPage: 1 }, () => this.loadNots());
        }
    }
    prevPage() {
        if (this.state.currentPage > 1) {
            this.setState({ currentPage: this.state.currentPage - 1 }, () => this.loadNots());
        }
    }
    nextPage() {
        var curr = this.state.currentPage;
        if (curr < this.state.pageCount) {
            this.setState({ currentPage: curr + 1 }, () => this.loadNots());
        }
    }
    lastPage() {
        var curr = this.state.currentPage;
        if (curr < this.state.pageCount) {
            this.setState({ currentPage: this.state.pageCount }, () => this.loadNots());
        }
    }

    renderForecastsTable(nots) {
        //        console.log(nots);
        return (
            <Table padding="none">
                <TableHead>
                    <TableRow>
                        <TableCell padding="dense">Deň</TableCell>
                        <TableCell>Počet</TableCell>
                        <TableCell>Auto/Maual</TableCell>
                        <TableCell></TableCell>

                    </TableRow>
                </TableHead>
                <TableBody>
                    {nots.map(not =>
                        <TableRow key={not.id} onDoubleClick={event => this.show(event, not.id)} hover>
                            <TableCell padding='dense' >{this.getDateTime(not.timestamp)}</TableCell>
                            <TableCell>{not.mailCount}</TableCell>
                            <TableCell>{not.isManual ? ("Manuálne (" + not.userName + ")") : "Automaticky"}</TableCell>
                            <TableCell>
                                <IconButton onClick={event => this.show(event, not.id)}><EditIcon /></IconButton >
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        );
    }
    show(event, id) {
        fetch('api/NotificationResults/' + id, { headers: authHeaderJson() })
            .then(res => res.json())
            .then(data => {
                //                console.log(data);
                this.setState({
                    notDataId: data.id,
                    datRes: data.timestamp,
                    textRes: data.resultText,
                    dialogOpen: true
                });
            })
            .catch(err => { console.error(err); })
    }


    handleClose() {
        this.setState({ dialogOpen: false });
    }

    render() {
        const { classes } = this.props;
        const { fullScreen } = this.props;

        let contents = this.state.loading ? <CircularProgress /> : this.renderForecastsTable(this.state.listData);

        return (
            <div className={classes.root} >
                <AppBar position="static">
                    <Toolbar>
                        <Typography className={classes.grow} variant="h6" color="inherit">Prehľad činnosti</Typography>
                        <IconButton color="inherit" onClick={this.loadNots.bind(this)}>
                            <IconRefresh />
                        </IconButton>

                        <IconButton color="inherit" disabled={this.state.currentPage <= 1} onClick={this.firstPage.bind(this)}>
                            <IconFirstPage fontSize="small" />
                        </IconButton>
                        <IconButton color="inherit" disabled={this.state.currentPage <= 1} onClick={this.prevPage.bind(this)}>
                            <IconPrev fontSize="small" />
                        </IconButton>
                        <Typography variant="body1" color="inherit">{this.state.currentPage}/{this.state.pageCount}</Typography>

                        <IconButton color="inherit" disabled={this.state.currentPage === this.state.pageCount} onClick={this.nextPage.bind(this)}>
                            <IconNext fontSize="small" />
                        </IconButton>
                        <IconButton color="inherit" disabled={this.state.currentPage === this.state.pageCount} onClick={this.lastPage.bind(this)}>
                            <IconLastPage fontSize="small" />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <Paper>
                    {contents}
                </Paper>

                <Dialog
                    fullScreen={fullScreen}
                    open={this.state.dialogOpen}
                    onClose={this.handleClose}
                    aria-labelledby="responsive-dialog-title"
                    scroll="paper"
                    maxWidth="lg"
                >
                    <DialogTitle id="responsive-dialog-title">{"Záznam"}</DialogTitle>
                    <DialogContent>
                        <Typography variant="body1">{this.getDateTime(this.state.datRes)}</Typography>
                        <List>
                            {this.state.textRes.trim().split('\n').map((line, idx) => <ListItem key={idx}><ListItemIcon><IconMail fontSize='small' /></ListItemIcon><ListItemText primary={line} /></ListItem>)}
                        </List>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={e => this.handleClose()} color="secondary" variant="outlined"><CancelIcon />Zrušiť</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
    handleWYSIWYG(val) { this.setState({ notDataMailTemplate: val }); }
}
NotificationsHist.propTypes = {
    classes: PropTypes.object.isRequired,
    fullScreen: PropTypes.bool.isRequired,
};

export default withMobileDialog()(withStyles(styles)(NotificationsHist));


// WEBPACK FOOTER //
// ./src/components/pssr/NotHistory.jsx